var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvertisingMegaphone = function SvgAdvertisingMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.132 12.8.448-1.175-1.046-2.744a.93.93 0 0 1 .36-1.107l2.458-1.605.767-2.834a.93.93 0 0 1 .942-.684l2.932.149L12.279.955a.93.93 0 0 1 1.165 0L15.73 2.8l2.932-.146a.93.93 0 0 1 .942.684l.767 2.834 2.458 1.605a.93.93 0 0 1 .36 1.107l-1.045 2.744 1.045 2.743a.93.93 0 0 1-.36 1.108l-2.458 1.6-.771 2.835a.93.93 0 0 1-.942.685l-2.932-.146-2.286 1.841M.75 19.769l1.656 2.609M9.908 8.147l6.294 9.916"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.871 17.541 2.075 21.857l-.994-1.566 9.158-11.622z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.056 20.924.876 1.346a2.04 2.04 0 0 0 2.906.614 2.256 2.256 0 0 0 .587-3.04l-.163-.236"
  })));
};
export default SvgAdvertisingMegaphone;